import React from 'react';

const Separator = ({ vertical, className = '', style: styleProp = {} }) => {
  const style = vertical ? {
    width: '0.5px',
    height: '100%',
  } : {
    width: '100%',
    height: '0.5px',
  };

  return (
    <span
      aria-hidden="true"
      style={{ ...style, ...styleProp }}
      className={`separator${vertical ? ' separator--vertical' : ''}${className ? ` ${className}` : ''}`}
    />
  );
}

export default Separator;
